import { render, staticRenderFns } from "./AdminPanelHome.vue?vue&type=template&id=3bbcbd6d&"
import script from "./AdminPanelHome.vue?vue&type=script&lang=js&"
export * from "./AdminPanelHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports